import React from 'react';
import classes from './style.module.scss';
type Iprops = {
  pendingColor?: string;
  completedColor?: string;
  value?: number;
};
const Progressbar = ({
  pendingColor = '#ffb8c9',
  completedColor = '#ff5353',
  value = 0,
}: Iprops) => {
  return (
    <span className={classes.pendingBar} style={{ background: pendingColor }}>
      <span
        className={classes.completedPrecentage}
        style={{ width: `${value}%`, background: completedColor }}
      ></span>
    </span>
  );
};
export default Progressbar;
